export default "__VITE_ASSET__EAXXw6To__"